namespace JupitersChoice {
    export class StartBaseGameWinningAudio {

        @inject('AudioModel') _audioModel: JupitersChoice.AudioModel;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        execute(): void {
            if (this._stateModel.currentSubgame === 'BaseGame') {
                this._audioModel.setBaseGameMusicToWinning();
            }
        }
    }
}